// The youtube_parser is from http://stackoverflow.com/a/8260383
const youtube_parser = url => {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  const match = url.match(regExp)
  if (match && match[7].length === 11) {
    return match[7]
  } else {
    return url
  }
}

const render = id => {
  return `<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/${id}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
}

const youtube = md => {
  let lines = md.match(/[^\r\n]+/g)

  if (lines === null || lines.length <= 0) {
    return md
  }

  const key = "@[youtube]("

  for (let i in lines) {
    const line = lines[i]

    if (!line.startsWith(key) || !line.endsWith(")")) {
      continue
    }

    const video = line.slice(key.length, line.length - 1)

    lines[i] = render(youtube_parser(video))
  }

  return lines.join("\n\r")
}

export { youtube }
